/**
 * Guest-info component modes, shared by the dashboard editor, the guest
 * portal, and the backend so client and server agree on how many guest
 * cards a component may hold.
 *
 * - `manual`: starts empty, the guest adds cards with "+".
 * - `auto`: one card per accompanying guest on the reservation, non-removable.
 * - `capped`: manual, but the guest cannot add more cards than the listing's
 *   max occupancy minus the primary signer.
 */
export const GUEST_INFO_MODES = ['manual', 'auto', 'capped'];
export const CAPPED_GUEST_INFO_MODE = 'capped';
/** Ceiling applied to every guest-info component, capped mode or not. */
export const GUEST_INFO_ABSOLUTE_MAX = 25;
export const parseGuestInfoMode = (raw) => GUEST_INFO_MODES.includes(raw ?? '') ? raw : 'manual';
/** True for the modes where the guest adds cards themselves. */
export const isGuestAddableMode = (mode) => mode === 'manual' || mode === CAPPED_GUEST_INFO_MODE;
/**
 * How many guest cards a component may hold. `cap` is the listing's max
 * occupancy minus the primary signer, or null when the listing capacity is
 * unknown (capped mode then behaves like plain manual).
 */
export const guestInfoCeiling = (mode, cap) => mode === CAPPED_GUEST_INFO_MODE && typeof cap === 'number'
    ? Math.max(0, Math.min(cap, GUEST_INFO_ABSOLUTE_MAX))
    : GUEST_INFO_ABSOLUTE_MAX;
export const clampGuestInfoCount = (count, mode, cap) => Math.max(0, Math.min(count, guestInfoCeiling(mode, cap)));
